import React, { useState, useEffect } from "react";

import { AlertMessage } from "components";

import { func_validation } from "functions";


export function useAlertMessage(props) {
    const { 
        addUser_errorMsg,
        updateUser_errorMsg,
        deleteUser_errorMsg,
    } = props;

    // States
    const [alertMsg, setAlertMsg] = useState([]);
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    // Error Messages
    function updateErrorMsg(msg) {
        if (func_validation.isStringTrimNotEmpty(msg)) {
            let alertMsg_new = func_validation.cloneArray(alertMsg);
            let index = func_validation.getArrayLength(alertMsg_new, 0);
    
            alertMsg_new.push(<p key={index}>{msg}</p>);
            setAlertMsg(alertMsg_new);
            setIsAlertMsgVisible(true);
        }
    } 
    useEffect(() => {
        updateErrorMsg(addUser_errorMsg);
    }, [addUser_errorMsg]);
    useEffect(() => {
        updateErrorMsg(updateUser_errorMsg);
    }, [updateUser_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deleteUser_errorMsg);
    }, [deleteUser_errorMsg]);

    let alertMessageDisplay = (
        <AlertMessage
            message={alertMsg}
            isVisible={isAlertMsgVisible}
            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
        />
    );

    return {
        alertMsg, setAlertMsg,
        isAlertMsgVisible,
        setIsAlertMsgVisible,
        alertMessageDisplay
    }
}